'use client'
import axios from '@/utils/axiosInterceptor';

const ctrl = {};

ctrl.getCertificadoAvaluo = async (predioClave, predioSolvencia) => {
    return axios.get(`/api/alcabala/certificado-avaluo?predioClave=${predioClave}&predioSolvencia=${predioSolvencia}`)
};

ctrl.calcularImpuesto = async (data) => {
    return axios.post('/api/alcabala/calcular-impuesto', data);
};

ctrl.certificadoEnTramite = async (numeroCertificado) => {
    return axios.get(`/api/alcabala/certificado-en-tramite/${numeroCertificado}`);
};

export default ctrl;